(function () {
	if (window.__kcCookiesReady) return;
	window.__kcCookiesReady = true;

	var banner = document.querySelector('[data-kc-cookies]');
	if (!banner) return;

	var row = banner.querySelector('[data-kc-cookies-row]');
	var settingsPanel = banner.querySelector('[data-kc-cookies-settings]');
	var customizeButton = banner.querySelector('[data-kc-cookies-customize]');
	var denyButton = banner.querySelector('[data-kc-cookies-deny]');
	var acceptButton = banner.querySelector('[data-kc-cookies-accept]');
	var switches = Array.prototype.slice.call(banner.querySelectorAll('[data-kc-cookies-switch]'));

	var expanded = false;
	var lastFocused = null;

	function currentToggles() {
		var toggles = {};
		switches.forEach(function (el) {
			var category = el.getAttribute('data-kc-cookies-switch');
			if (category === 'necessary') return;
			toggles[category] = el.getAttribute('aria-checked') === 'true';
		});
		return toggles;
	}

	function setSwitch(el, on) {
		el.setAttribute('aria-checked', on ? 'true' : 'false');
	}

	function applyConsentToSwitches(consent) {
		switches.forEach(function (el) {
			var category = el.getAttribute('data-kc-cookies-switch');
			if (category === 'necessary') return;
			setSwitch(el, !!consent[category]);
		});
	}

	function setCustomizeLabel() {
		customizeButton.textContent = expanded
			? customizeButton.getAttribute('data-label-hide')
			: customizeButton.getAttribute('data-label-show');
		customizeButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
	}

	function setDenyLabel() {
		denyButton.textContent = expanded
			? denyButton.getAttribute('data-label-save')
			: denyButton.getAttribute('data-label-deny');
	}

	function openSettings(prefillFromCurrentConsent) {
		expanded = true;
		settingsPanel.hidden = false;
		if (prefillFromCurrentConsent && window.Shopify && window.Shopify.customerPrivacy) {
			var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
			applyConsentToSwitches({
				analytics: consent.analytics === 'yes',
				marketing: consent.marketing === 'yes'
			});
		}
		setCustomizeLabel();
		setDenyLabel();
		updateBodyPadding();
	}

	function closeSettings() {
		expanded = false;
		settingsPanel.hidden = true;
		setCustomizeLabel();
		setDenyLabel();
		updateBodyPadding();
	}

	var CHOICE_KEY = 'kc_cookies_choice_made';

	function saveConsent(consentValues, callback) {
		if (!(window.Shopify && window.Shopify.customerPrivacy)) return;
		window.Shopify.customerPrivacy.setTrackingConsent(
			{
				analytics: consentValues.analytics,
				marketing: consentValues.marketing,
				preferences: true,
				sale_of_data: consentValues.marketing
			},
			function () {
				// Belt-and-suspenders: Shopify's own consent cookie is the
				// real signal other scripts should check, but if it doesn't
				// stick for any reason (e.g. Shopify's own native banner
				// still being enabled alongside this one), this flag is
				// what stops the banner from reappearing on every page.
				try {
					localStorage.setItem(CHOICE_KEY, '1');
				} catch (e) {}

				document.dispatchEvent(
					new CustomEvent('kc:consent', {
						detail: {
							analytics: consentValues.analytics,
							marketing: consentValues.marketing,
							preferences: true,
							sale_of_data: consentValues.marketing
						}
					})
				);
				if (typeof callback === 'function') callback();
			}
		);
	}

	function hideBanner() {
		banner.hidden = true;
		document.body.style.paddingBottom = '';
		var focusTarget = lastFocused && document.contains(lastFocused) ? lastFocused : document.getElementById('MainContent');
		if (focusTarget) focusTarget.focus();
	}

	function showBanner() {
		lastFocused = document.activeElement;
		banner.hidden = false;
		updateBodyPadding();
	}

	var resizeObserver =
		window.ResizeObserver &&
		new ResizeObserver(function () {
			updateBodyPadding();
		});

	function updateBodyPadding() {
		if (banner.hidden) {
			document.body.style.paddingBottom = '';
			return;
		}
		document.body.style.paddingBottom = banner.offsetHeight + 'px';
	}

	if (resizeObserver) resizeObserver.observe(banner);

	customizeButton.addEventListener('click', function () {
		if (expanded) {
			closeSettings();
		} else {
			openSettings(false);
		}
	});

	denyButton.addEventListener('click', function () {
		if (expanded) {
			saveConsent(currentToggles(), hideBanner);
		} else {
			saveConsent({ analytics: false, marketing: false }, hideBanner);
		}
	});

	acceptButton.addEventListener('click', function () {
		saveConsent({ analytics: true, marketing: true }, hideBanner);
	});

	switches.forEach(function (el) {
		if (el.getAttribute('data-kc-cookies-switch') === 'necessary') return;
		el.addEventListener('click', function () {
			setSwitch(el, el.getAttribute('aria-checked') !== 'true');
		});
	});

	window.kcCookies = {
		open: function () {
			showBanner();
			openSettings(true);
		}
	};

	document.addEventListener('click', function (event) {
		if (event.target.closest('[data-kc-cookies-reopen]')) {
			window.kcCookies.open();
		}
	});

	if (!(window.Shopify && window.Shopify.loadFeatures)) return;

	window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
		if (error) return;
		var choiceAlreadyMade = false;
		try {
			choiceAlreadyMade = localStorage.getItem(CHOICE_KEY) === '1';
		} catch (e) {}

		if (!choiceAlreadyMade && window.Shopify.customerPrivacy.shouldShowBanner()) {
			showBanner();
		}
	});
})();
